export { default } from './MobileDownloadAd';
